<template>
  <div class="tv-stations__wrapper">
      <div class="container">
          <div class="columns">
              <div class="column" v-for="(item, key) in footerLogos" :key="key">
                  <a :href="item.url" target="_blank" class="tv-stations__item">
                      <img :src="parseImageUrl(item.image.url, 0, 42)" class="img-responsive">
                  </a>
              </div>
          </div>
      </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useFooterStore } from "@/stores/footer";
import { storeToRefs } from 'pinia';
import {useUtils} from "@/composables/useUtils";

const { parseImageUrl } = useUtils()
const footerStore = useFooterStore()
const { footerLogos } = storeToRefs(footerStore)
const { fetchFooterLogos } = footerStore

onMounted(() => {
    fetchFooterLogos()
})
</script>

<style lang="scss">
@import "@/assets/scss/components/elements/tv-stations-logo-footer.scss";
</style>